<template>
    <div class="index">
        <div style="width:72px;display:flex;flex-direction:column;background:rgba(38, 47, 62, 1)">
            <div style="width:72px;height:70px;background:rgba(38, 47, 62, 1);text-align:center;padding-top:30px">
                <img src="./../assets/img/logo.png" alt="">
            </div>
            <ul style="width:72px;flex:1" class="icon-list">
                <li v-for="(item,index) in menuList" :key='index' @click="chooseTab(item.key)" :class="{'active':currentTab==item.key}" style="position:relative;">
                    <a @click="linkPage(item)">
                        <a-icon :type="item.icon" theme="filled" />
                        <div>
                            {{item.title}}
                        </div>
                    </a>
                    <span class="number-unread" v-if="item.title=='通讯录'&&numberData!=0">{{numberData}}</span>
                </li>
            </ul>
            <div class="personal-center">
                <span v-if="loginInfo.avatar==''" style="display:inline-block;width:40px;height:40px;text-align:center;line-height:40px;color:#fff;font-size:14px;background:rgba(58, 220, 255, 1);border-radius:20px;margin:0 16px">{{loginInfo.name.length>2?loginInfo.name.substr(-2,2):loginInfo.name}}</span>
                <img style="display:inline-block;width:40px;height:40px;text-align:center;line-height:40px;color:#fff;font-size:14px;background:rgba(58, 220, 255, 1);border-radius:20px;margin:0 16px" v-if="loginInfo.avatar!=''" :src="loginInfo.avatar" alt="">
                <div class="personal-box">
                    <div @click="routerLink" class="item-box" style="height:44px;line-height:44px;text-align:center;padding:0 24px;cursor:pointer;">
                        <div style="width:100%;height:100%;border-bottom:1px solid rgba(229, 229, 229, 1)">
                            <a-icon style="color:rgba(158, 172, 196, 0.7);" type="user" />
                            <span style="color:rgba(18, 18, 18, 1);font-size:13px;margin-left:8px;">个人中心</span>
                        </div>
                    </div>
                    <div @click="loginOut" class="item-box" style="height:44px;line-height:44px;text-align:center;padding:0 24px;cursor:pointer;">
                        <div style="width:100%;height:100%;">
                            <a-icon style="color:rgba(158, 172, 196, 0.7);" type="poweroff" />
                            <span style="color:rgba(18, 18, 18, 1);font-size:13px;margin-left:8px;">退出登录</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
        <div class="content">
            <router-view></router-view>
        </div>
        <a-modal v-model="visible" class="chat-modal" footer='' width='980px' :closable='false'>
            <div style="width:100%;height:760px;display:flex;box-shadow: 0px 2px 16px 0px rgba(0, 0, 0, 0.12);">
                <div style="text-align:center;width:100%;padding-top:100px;font-size:20px;color:#000">还在开发中，敬请期待~</div>
                <a-icon @click="closeChat" style="position:absolute;right:20px;top:20px;font-size:18px;color:rgba(158, 172, 196, 1);cursor:pointer;" type="close" />
            </div>
        </a-modal>
    </div>
</template>

<script>
    export default {
        name: 'Index',
        data() {
            return {
                currentTab: 2,
                visible: false,
                currentSelection: 1,
                memberInfoBool: false,
                menuList: [],
                loginInfo: '',
                numberData: 0,
                intervalId: null,
            }
        },
        methods: {
            chooseTab(param) {
                this.sessionData('set','currentTab',param);
                this.currentTab = param
            },
            openChat() {
                this.visible = true
            },
            closeChat() {
                this.visible = false
            },
            selectChat(data) {
                this.currentSelection = data
            },
            routerLink() {
                this.$router.push("/PersonalInfo")
            },
            loginOut() {
                sessionStorage.removeItem('token')
                this.$router.push("/Login")
            },
            hideMemberInfo() {
                this.memberInfoBool = false
            },
            showMemberInfo() {
                this.memberInfoBool = true
            },
            queryBasicInfo() {
                this.axios(
                    {
                        method:'get',
                        url:'/api/menu/list', 
                    }
                )
                .then(response=> {
                    if(response.data.code == 0){
                        this.menuList = response.data.data
                    }else{
                        this.$message.error(response.data.userTip);
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },
            linkPage(item) {
                this.$router.push({
                    path:'/'+item.component,
                    query: { params: JSON.stringify(item.children) }
                })
            },
            queryLoginInfo() {
                this.axios(
                    {
                        method:'get',
                        url:'/api/serviceProviderUser', 
                    }
                )
                .then(response=> {
                    if(response.data.code == 0){
                        this.loginInfo = response.data.data
                    }else{
                        this.$message.error(response.data.userTip);
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },
            queryNumberInfo() {
                this.axios(
                    {
                        method:'get',
                        url:'/api/comment/unReadCount', 
                    }
                )
                .then(response=> {
                    if(response.data.code == 0){
                        this.numberData = response.data.data.count
                    }else{
                        this.$message.error(response.data.userTip);
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },
            startFetching() {
                this.queryNumberInfo(); // 立即请求一次数据
                this.intervalId = setInterval(
                    this.queryNumberInfo, 
                5000); // 每 5 秒请求一次
            },
            stopFetching() {
                clearInterval(this.queryNumberInfo); // 清除定时器
            },
        },
        mounted: function() {
            this.queryBasicInfo()
            this.queryLoginInfo()
            this.startFetching();
            if(this.sessionData('get','currentTab')!=undefined&&this.sessionData('get','currentTab')!=''){
                this.currentTab = this.sessionData('get','currentTab')
            }
            // document.onclick = (e)=> {
            //     console.log(e)
            // }
        },
        beforeDestroy() {
            this.stopFetching(); // 组件销毁前清除定时器
        },
    }
</script>

<style scoped lang="less">
    .index{
        display: flex;
        height: 100%;
        .icon-list{
            padding-top: 28px;
            li{
                text-align: center;
                font-size: 14px;
                height: 85px;
                cursor: pointer;
                padding-top: 20px;
                box-sizing: border-box;
                transition:padding-top 0.5s;
                i{
                    color: rgba(139, 169, 194, 1);
                    font-size: 28px;
                    display: block;
                    text-align: center;
                }
                a{
                    display: inline-block;
                    width: 100%;
                    height: 100%;
                }
                div{
                    display: none;
                    transition:display 0.5s;
                }
            }
            li.active{
                div{
                    display: block;
                    color: #fff;
                }
                i{
                    color: rgba(255, 255, 255, 1);
                }
            }
            li:hover{
                padding-top: 12px;
                i{
                    color: rgba(255, 255, 255, 1);
                }
                div{
                    display: block;
                    color: rgba(255, 255, 255, 1);
                }
            }

        }
        .content{
            flex: 1;
        }
        .personal-center{
            height: 40px;
            position: relative;
            margin-bottom: 20px;
            cursor: default;
        }
        .personal-center:hover{
            .personal-box{
                display: inline-block;
            }
        }
        .personal-box{
            display: none;
            width: 144px;
            height: 104px;
            box-shadow: 0px 2px 16px 0px rgba(0, 0, 0, 0.12);
            position: absolute;
            top: -65px;
            right: -144px;
            z-index: 1000;
            padding: 8px 0;
            background: #fff;
            .item-box:hover{
                background: #F3F3F3;
            }
        }
        .number-unread{
            position: absolute;
            background: rgba(246, 76, 79, 1);
            color: #fff;
            font-size: 12px;
            height: 18px;
            line-height: 16px;
            min-width: 18px;
            right: 15px;
            top: 15px;
            border-radius: 9px;
            text-align: center;
            padding: 0 4px;
        }
    }
    .chat-modal{
        .name-list{
            overflow-y: auto;
            div{
                height: 48px;
                padding: 13px 0 0 20px;
                cursor: pointer;
                span:nth-child(1){
                    width: 24px;
                    height: 24px;
                    border-radius: 12px;
                    color: rgba(255, 255, 255, 1);
                    font-size: 12px;
                    margin-right: 8px;
                    background: rgba(78, 138, 250, 1);
                    display: inline-block;
                    text-align: center;
                    line-height: 24px;
                }
                span:nth-child(2){
                    color: rgba(18, 18, 18, 1);
                    font-size: 13px;
                }
            }
            div:hover{
                background: rgba(240, 242, 243, 0.5);
            }
        }
        .chat-tab{
            margin-top: 8px;
            span{
                display:inline-block;
                color: rgba(158, 172, 196, 1);
                font-size: 13px;
                cursor: pointer;
                padding-bottom: 6px;
                margin-right: 32px;
            }
            span.active{
                color: rgba(58, 220, 255, 1);
                font-weight: bold;
                border-bottom: 3px solid rgba(58, 220, 255, 1);
            }
        }
        .right-menu{
            width: 51px;
            border-left: 1px solid rgba(229, 229, 229, 1);
            height: 100%;
            position: relative;
            .menu-list{
                text-align: center;
                color: rgba(158, 172, 196, 1);
                margin-top: 20px;
                cursor: pointer;
            }
            .active{
                color: rgba(58, 220, 255, 1);
            }
        }
        .personal-info{
            .info-list{
                margin-bottom: 24px;
                .info-title{
                    color: rgba(158, 172, 196, 1);
                    font-size: 13px;
                }
                .info-content{
                    color: rgba(18, 18, 18, 1);
                    font-size: 13px;
                    img{
                        width: 80px;
                    }
                }
            }
            
        }
    }
</style>
